export default function () {
  return {
    general: {}
  }
}
